import { createRouter, createWebHistory } from 'vue-router'

import store from '@/store'

const routes = [
  {
    path: '/:catchAll(.*)',
    name: 'All',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
  },
  {
    path: '/ai',
    name: 'AI Configuration',
    component: () => import(/* webpackChunkName: "ai_configuration" */ '../views/AIConfiguration/index.vue')
  },
  {
    path: '/ai/keyword',
    name: 'Keyword Data',
    component: () => import(/* webpackChunkName: "keyword_data" */ '../views/AIConfiguration/KeywordData/index.vue')
  },
  {
    path: '/ai/keyword/question/:id',
    name: 'Question Topic',
    component: () => import(/* webpackChunkName: "question_topic" */ '../views/AIConfiguration/KeywordData/QuestionTopic/index.vue')
  },
  {
    path: '/ai/alias',
    name: 'Alias',
    component: () => import(/* webpackChunkName: "alias" */ '../views/AIConfiguration/Alias/index.vue')
  },
  {
    path: '/ai/mrc',
    name: 'Mrc',
    component: () => import(/* webpackChunkName: "alias" */ '../views/AIConfiguration/MrcAiScan/index.vue')
  },
  {
    path: '/talk',
    name: 'Small Talk',
    component: () => import(/* webpackChunkName: "small_talk" */ '../views/SmallTalk/index.vue')
  },
  {
    path: '/conversation',
    name: 'Conversation Review',
    component: () => import(/* webpackChunkName: "conversation_check" */ '../views/ConversationCheck/index.vue')
  },
  {
    path: '/event',
    name: 'Event Manager',
    component: () => import(/* webpackChunkName: "conversation_check" */ '../views/EventManager.vue')
  },
  {
    path: '/interface',
    name: 'Interface Settings',
    component: () => import(/* webpackChunkName: "interface_settings" */ '../views/InterfaceSettings/index.vue')
  },
  {
    path: '/interface/avatar',
    name: 'Virtual Avatar',
    component: () => import(/* webpackChunkName: "virtual_avatar" */ '../views/InterfaceSettings/VirtualAvatar/index.vue')
  },
  {
    path: '/setting',
    name: 'Admin Settings',
    component: () => import(/* webpackChunkName: "admin_settings" */ '../views/AdminSettings/index.vue')
  },
  {
    path: '/setting/users',
    name: 'User Settings',
    component: () => import(/* webpackChunkName: "admin_settings" */ '../views/AdminSettings/UserSettings/index.vue')
  },
  {
    path: '/setting/logs',
    name: 'Logs',
    component: () => import(/* webpackChunkName: "admin_settings" */ '../views/AdminSettings/Logs/index.vue')
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import(/* webpackChunkName: "chat" */ '../views/Chat.vue')
  },
  {
    path: '/live_video',
    name: 'Live Video',
    component: () => import(/* webpackChunkName: "live_video" */ '../views/LiveVideo.vue')
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import(/* webpackChunkName: "message" */ '../views/Message.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // avoid redirect to same page
  if (to.path === from.path) return

  // Login Status
  const loggedIn = store.state.auth.status

  // redirect to login page if not logged in but trying to access a restricted page
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  const page_access = store.state.auth.page_access
  const privileges = store.state.auth.privileges.privileges
  const device_id = store.state.auth.user_info.project_id
  const is_operator = store.state.auth.privileges.role === 'Operator'

  let back_to_landing_page = false

  if (authRequired && !loggedIn) return next('/login')
  // prevent logged in user access login page again
  else if (to.path === '/login' && loggedIn) back_to_landing_page = true
  // redirect to dashboard page if no page access right
  else if (page_access !== 'all' && loggedIn && !page_access.includes('/'.concat(to.path.split('/')[1]))) back_to_landing_page = true
  // redirect to setting if no logs page access
  else if (to.path === '/setting/logs' && !privileges.project[device_id]) back_to_landing_page = true
  else if (to.path === '/setting/logs' && !privileges.project[device_id].includes('Project.Log.View')) back_to_landing_page = true

  if (back_to_landing_page) {
    if (is_operator) return next('/setting')
    else return next('/dashboard')
  }

  next()
})

export default router
